import { render } from "./AddFilms.vue?vue&type=template&id=d30960be"
import script from "./AddFilms.vue?vue&type=script&lang=js"
export * from "./AddFilms.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__